import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  type: "button",
  disabled: ""
}
const _hoisted_2 = ["href"]

import { computed, inject } from "vue";
import { Config } from "@/config";

const title = "Participant Token Created";

export default /*#__PURE__*/_defineComponent({
  __name: 'SendTokenEmail',
  props: {
    token: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const config = inject<Config>("config") as Config;
const cc = config.CCEmails.join(", ");

const href = computed((): string => {
  const link = window.location + "#" + props.token;
  return (
    "mailto:?subject=" +
    encodeURIComponent(title) +
    "&cc=" +
    cc +
    "&body=" +
    encodeURIComponent(`Hi!

A new login token has been created for you:
${props.token}


You can enter this on the login page of the app,
or follow this link for more options:
${link}

Do not lose this token.

Regards,
The ContextAware App Team
    `)
  );
});

return (_ctx: any,_cache: any) => {
  return (props.disabled)
    ? (_openBlock(), _createElementBlock("button", _hoisted_1, "Send Email"))
    : (_openBlock(), _createElementBlock("a", {
        key: 1,
        href: href.value,
        target: "_blank",
        class: "button"
      }, "Send Email", 8, _hoisted_2))
}
}

})